// 事件总线
var EventBus = function (unique) {
  this.unique = unique || new Date().getTime();
  this.topics = {};
}
EventBus.prototype.on = function (topic, func) {
  var cbs = this.topics[this.unique + topic];
  cbs ? cbs.push(func) : this.topics[this.unique + topic] = [];
  if (!cbs) {
    this.topics[this.unique + topic].push(func)
  }
}
EventBus.prototype.emit = function (topic) {
  var cbs = this.topics[this.unique + topic];
  var args = Array.prototype.slice.call(arguments, 1);
  if (cbs) {
    for (var i = 0; i < cbs.length; i++) {
      cbs[i].apply(this, args);
    }
  }
}
EventBus.prototype.off = function (topic) {
  var cbs = this.topics[this.unique + topic];
  if (cbs) {
    var i = cbs.length;
    while (i--) {
      cbs.splice(i, 1);
    }
  }
}

export default {
  eventBuses: [],
  create: function (unique) {
    for (var i = 0; i < this.eventBuses.length; i++) {
      if (this.eventBuses[i].unique === unique) {
        return this.eventBuses[i];
      }
    }
    var eventBus = new EventBus(unique);
    this.eventBuses.push(eventBus);
    return eventBus;
  }
};



// WEBPACK FOOTER //
// ./packages/utils/eventBus.js